import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Select, Space, Switch, Table } from 'antd';
import type { ParamField, ParamType } from '@gw/shared';

const TYPE_OPTIONS: { value: ParamType; label: string }[] = [
  { value: 'textarea', label: 'Văn bản dài' },
  { value: 'text', label: 'Văn bản' },
  { value: 'number', label: 'Số' },
  { value: 'select', label: 'Chọn (select)' },
  { value: 'bool', label: 'Bật/tắt' },
  { value: 'json', label: 'JSON' },
  { value: 'image', label: 'Ảnh' },
  { value: 'video', label: 'Video' },
  { value: 'audio', label: 'Âm thanh' },
  { value: 'media', label: 'Ảnh/Video' },
  { value: 'image[]', label: 'Nhiều ảnh' },
  { value: 'video[]', label: 'Nhiều video' },
];

/**
 * Khai bao THAM SO DAU VAO CONG KHAI cua workflow — chinh la thu phan mem thu 3 nhin thay
 * trong /api/v1/catalog. Dung ten CANONICAL (prompt, input_image, reference_images, …).
 */
export default function WorkflowParamsEditor({
  value,
  onChange,
}: {
  value: ParamField[];
  onChange: (v: ParamField[]) => void;
}) {
  const rows = value ?? [];
  const patch = (i: number, p: Partial<ParamField>) =>
    onChange(rows.map((r, idx) => (idx === i ? { ...r, ...p } : r)));

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Table
        size="small"
        rowKey={(_, i) => String(i)}
        pagination={false}
        dataSource={rows}
        locale={{ emptyText: 'Chưa có tham số — bấm "Thêm tham số".' }}
        columns={[
          {
            title: 'Tên (canonical)',
            width: 190,
            render: (_, __, i) => (
              <Input
                placeholder="prompt"
                value={rows[i].name}
                onChange={(e) => patch(i, { name: e.target.value.trim() })}
              />
            ),
          },
          {
            title: 'Nhãn hiển thị',
            render: (_, __, i) => (
              <Input placeholder="Mô tả ảnh" value={rows[i].label} onChange={(e) => patch(i, { label: e.target.value })} />
            ),
          },
          {
            title: 'Kiểu',
            width: 160,
            render: (_, __, i) => (
              <Select
                style={{ width: '100%' }}
                value={rows[i].type}
                options={TYPE_OPTIONS}
                onChange={(t) => patch(i, { type: t })}
              />
            ),
          },
          {
            title: 'Tùy chọn (select)',
            width: 200,
            render: (_, __, i) =>
              rows[i].type === 'select' ? (
                <Input
                  placeholder="1:1, 16:9, 9:16"
                  value={(rows[i].options || []).join(', ')}
                  onChange={(e) =>
                    patch(i, { options: e.target.value.split(',').map((s) => s.trim()).filter(Boolean) })
                  }
                />
              ) : null,
          },
          {
            title: 'Bắt buộc',
            width: 90,
            render: (_, __, i) => <Switch checked={!!rows[i].required} onChange={(v) => patch(i, { required: v })} />,
          },
          {
            title: '',
            width: 50,
            render: (_, __, i) => (
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => onChange(rows.filter((_, idx) => idx !== i))}
              />
            ),
          },
        ]}
      />
      <Button
        icon={<PlusOutlined />}
        onClick={() => onChange([...rows, { name: '', label: '', type: 'text' as ParamType }])}
      >
        Thêm tham số
      </Button>
    </Space>
  );
}
